import React from 'react';
import PropTypes from 'prop-types';

const FooterContext = React.createContext(undefined);

function FooterProvider({ children }) {
  const footerRef = React.useRef();

  const [value] = React.useState({ footerRef });

  return (
    <FooterContext.Provider value={value}>
      {children}
    </FooterContext.Provider>
  );
}

function useFooterContext() {
  const context = React.useContext(FooterContext);

  if (context === undefined) {
    throw new Error('useFooter must be used within a FooterProvider');
  }

  return context;
}

FooterProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export {
  FooterProvider,
  useFooterContext,
};
